const isMobile = () => window.matchMedia("only screen and (max-width: 991px)").matches;

export { isMobile };